// Styles
import './WorkPage.css'

// Components
import Header from '../components/Header'
import Body from '../components/Body'

const WorkPage = () => {
  return (
    <div className='WorkPage'>
        <Header />
        <Body />
    </div>
  )
}

export default WorkPage